import loadable from '@loadable/component';

export const AsyncOverdueDebtSchedule = loadable(
  () => import('./OverdueDebtSchedule'),
);
